var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FormControl, FormLabel, FormErrorMessage, FormHelperText, Switch as ChakraSwitch, } from "@chakra-ui/react";
/** This component is a wrapper around Switch component of Chakra-UI */
export const Switch = (props) => {
    const { errorMessage, helpText, id, isInvalid, isRequired, label, value } = props, rest = __rest(props, ["errorMessage", "helpText", "id", "isInvalid", "isRequired", "label", "value"]);
    return (_jsxs(FormControl, { isInvalid: isInvalid, isRequired: isRequired, id: id, children: [label && _jsx(FormLabel, { htmlFor: id, children: label }), _jsx(ChakraSwitch, Object.assign({ isChecked: value }, rest)), errorMessage && _jsx(FormErrorMessage, { children: errorMessage }), helpText && _jsx(FormHelperText, { children: helpText })] }));
};
//# sourceMappingURL=switch.js.map